import React from 'react';
import {
  joinCommunity,
  withdrawFromCommunity,
} from '../service/CommunitySetupService';
import {
  CommunityOptInAction,
  CommunityOptInStateType,
} from './useCommunityOptInReducer';
import { UserInfoAction } from '@xolv-mybrightlink/common';

export async function acceptCommunityOptIn(
  dispatch: React.Dispatch<CommunityOptInAction>,
  dispatchUserInfo: React.Dispatch<UserInfoAction>,
) {
  try {
    dispatch({ type: CommunityOptInStateType.ACCEPTING });
    await joinCommunity();
    dispatch({ type: CommunityOptInStateType.ACCEPTED });
    dispatchUserInfo({ type: 'COMMUNITY_OPT_IN' });
  } catch (exception) {
    dispatch({ type: CommunityOptInStateType.ACCEPTING_FAILED });
  }
}

export async function withdrawCommunityOptIn(
  dispatch: React.Dispatch<CommunityOptInAction>,
) {
  await withdrawFromCommunity();
  dispatch({
    type: CommunityOptInStateType.INITIAL,
    payload: { hasWithdrawnBefore: true },
  });
}
